export const POS = [{
    x: 400,
    y: 750,
    h: 560,
    w: 560,
}, {
    x: 980,
    y: 1500,
    h: 560,
    w: 560,
}, {
    x: 400,
    y: 2250,
    h: 560,
    w: 560,
}, {
    x: 980,
    y: 3000,
    h: 560,
    w: 560,
}, {
    x: 400,
    y: 3750,
    h: 560,
    w: 560,
}, {
    x: 980,
    y: 4500,
    h: 560,
    w: 560,
}];